import { Component, Input, OnInit } from '@angular/core';
import { PricingInfo } from 'src/app/interfaces/contentful/pricing-info';
import { ContentfulService } from 'src/app/services/contentful.service';

@Component({
  selector: 'app-pricing-info',
  templateUrl: './pricing-info.component.html',
  styleUrls: ['./pricing-info.component.scss']
})
export class PricingInfoComponent implements OnInit {

  @Input() contentId = '';

  public content: PricingInfo | undefined;
  public error: string | undefined;

  constructor(private contentfulService: ContentfulService) { }

  ngOnInit(): void {
    if (!this.content) {
      this.contentfulService.getContentItem(this.contentId)
      .then(content => {
        console.log(`[Pricing Component] Contentful returned the folowing for ID: ${this.contentId}`, content)
        this.content = content.fields;
      })
      .catch(error => {
        this.error = "Error: content could not be loaded."
      })
    }
  }

}
